document.addEventListener('DOMContentLoaded', () => {
  // Target the Unified Class (Found in the new Liquid file)
  const slider = document.querySelector('.tr-unified-slider .slideshow');
  
  // If the slider isn't on the page, stop the script.
  if (!slider) return;

  // Add marker class to tell CSS that JS is running (This hides the fallback slide)
  slider.classList.add('tr-js-running');

  // Find all slides
  const slides = slider.querySelectorAll('.slideshow__slide');
  
  // If there's only 1 slide, we don't need to fade anything.
  if (slides.length < 2) return;

  let index = 0;
  // Speed setting: 5000ms = 5 seconds
  const intervalTime = 5000; 

  // Start the infinite loop
  setInterval(() => {
    // 1. Remove 'tr-active' from the current slide (it fades out via CSS)
    slides[index].classList.remove('tr-active');
    
    // 2. Calculate the next index
    index = (index + 1) % slides.length;
    
    // 3. Add 'tr-active' to the next slide (it fades in via CSS)
    slides[index].classList.add('tr-active');
  }, intervalTime);
});